import { signatureV2 } from '@crab/veekd'
import axios from 'axios'

const EASYCOUNTER_URL = 'https://easycounter-pdf-srv.zhhainiao.com/'

const EASYCOUNTER_APP_ID = 'pdf_web'
const EASYCOUNTER_ACCESS_KEY = 'RRORJKSyvtxskmqsbYVHeORCSIZ26gjZ'
const EASYCOUNTER_ACCESS_SECRET = 'r6QHQfxsHaRlVXkFu4NlPuog4qz5fSLNLGw1PfhdMuy2nhItE9jaCwZbhrvBQwyg'

export const service = axios.create({
  baseURL: EASYCOUNTER_URL,
  timeout: 5000, // request timeout
})
service.interceptors.request.use(signatureV2(EASYCOUNTER_APP_ID, EASYCOUNTER_ACCESS_KEY, EASYCOUNTER_ACCESS_SECRET))
